var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsMenuIconV4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96295 12.9877C2.96295 13.4282 3.42654 13.7147 3.82056 13.5177L4.61727 13.1193L5.41399 13.5177C5.58082 13.6011 5.77719 13.6011 5.94402 13.5177L6.74073 13.1193L7.53744 13.5177C7.70427 13.6011 7.90064 13.6011 8.06747 13.5177L8.86419 13.1193L9.6609 13.5177C9.82773 13.6011 10.0241 13.6011 10.1909 13.5177L10.9876 13.1193L11.7844 13.5177C12.1784 13.7147 12.642 13.4282 12.642 12.9877V3.70431C12.642 2.64067 11.7805 1.77779 10.7175 1.77779H3.55554C3.22826 1.77779 2.96295 2.0431 2.96295 2.37038V12.9877ZM4.14814 12.0288V2.96297H10.7175C11.1255 2.96297 11.4568 3.29478 11.4568 3.70431V12.0288L11.2527 11.9268C11.0858 11.8434 10.8895 11.8434 10.7226 11.9268L9.92591 12.3251L9.1292 11.9268C8.96237 11.8434 8.766 11.8434 8.59917 11.9268L7.80246 12.3251L7.00574 11.9268C6.83891 11.8434 6.64254 11.8434 6.47571 11.9268L5.679 12.3251L4.88229 11.9268C4.71546 11.8434 4.51909 11.8434 4.35226 11.9268L4.14814 12.0288Z",
    fill: "#45455A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72846 9.20989C5.40118 9.20989 5.13586 8.94458 5.13586 8.6173C5.13586 8.29002 5.40118 8.0247 5.72846 8.0247H7.85191C8.17919 8.0247 8.44451 8.29002 8.44451 8.6173C8.44451 8.94458 8.17919 9.20989 7.85191 9.20989H5.72846Z",
    fill: "#45455A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72846 7.35186C5.40118 7.35186 5.13586 7.08654 5.13586 6.75926C5.13586 6.43198 5.40118 6.16667 5.72846 6.16667H9.97537C10.3026 6.16667 10.568 6.43198 10.568 6.75926C10.568 7.08654 10.3026 7.35186 9.97537 7.35186H5.72846Z",
    fill: "#45455A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32105 5.49382C6.99377 5.49382 6.72845 5.22851 6.72845 4.90123C6.72845 4.57395 6.99377 4.30864 7.32105 4.30864H9.97537C10.3026 4.30864 10.568 4.57395 10.568 4.90123C10.568 5.22851 10.3026 5.49382 9.97537 5.49382H7.32105Z",
    fill: "#45455A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsMenuIconV4);
export default __webpack_public_path__ + "static/media/reports-menu-icon-v4.6567c1e16ba4bf49b527b680c44fb34c.svg";
export { ForwardRef as ReactComponent };